/**
 * Wheel500 Mock Engine
 * ВЕСЬ ИЗОЛИРОВАННЫЙ МОК РЕЖИМА WHEEL500.
 *
 * Назначение: эмулировать бекенд режима Wheel500 на фронте — раунды, ставки ботов,
 * результаты и распределение секторов. Когда появится настоящий API, достаточно
 * заменить `createWheel500MockEngine` на реальный сервис (или флагом отключить мок).
 *
 * Ничего из этого файла НЕ должно использоваться вне фичи wheel500.
 */

// ============================================================================
// Конфиг цветов и множителей
// ============================================================================

export const WHEEL500_COLORS = {
  blue:   { multiplier: 2,  label: 'Синий',     hex: '#3B82F6', ringClass: 'ring-blue-400/60',    bgClass: 'bg-blue-500',    softClass: 'bg-blue-500/15 border-blue-400/40',    textClass: 'text-blue-200' },
  green:  { multiplier: 3,  label: 'Зелёный',   hex: '#10B981', ringClass: 'ring-emerald-400/60', bgClass: 'bg-emerald-500', softClass: 'bg-emerald-500/15 border-emerald-400/40', textClass: 'text-emerald-200' },
  purple: { multiplier: 5,  label: 'Фиолет.',   hex: '#A855F7', ringClass: 'ring-purple-400/60',  bgClass: 'bg-purple-500',  softClass: 'bg-purple-500/15 border-purple-400/40',  textClass: 'text-purple-200' },
  red:    { multiplier: 10, label: 'Красный',   hex: '#EF4444', ringClass: 'ring-red-400/60',     bgClass: 'bg-red-500',     softClass: 'bg-red-500/15 border-red-400/40',     textClass: 'text-red-200' },
  gold:   { multiplier: 50, label: 'Золотой',   hex: '#F59E0B', ringClass: 'ring-amber-400/70',   bgClass: 'bg-amber-400',   softClass: 'bg-amber-400/15 border-amber-400/50',  textClass: 'text-amber-200' }
}

export const WHEEL500_COLOR_KEYS = ['blue', 'green', 'purple', 'red', 'gold']

// ============================================================================
// 50 секторов: фиксированное распределение (детерминированное, для предсказуемого визуала)
// 25 blue (x2), 15 green (x3), 7 purple (x5), 2 red (x10), 1 gold (x50)
// ============================================================================

export const WHEEL500_SECTORS = (() => {
  // Жёстко зашитая раскладка: gold в центре, red равномерно, purple — между green, остальное blue.
  // Длина 50.
  const layout = [
    'blue','green','blue','purple','blue','green','blue','red','blue','green',
    'blue','purple','blue','green','blue','purple','blue','green','blue','green',
    'blue','purple','blue','green','blue','gold','blue','green','blue','purple',
    'blue','green','blue','purple','blue','green','blue','green','blue','red',
    'blue','green','blue','purple','blue','green','blue','green','blue','green'
  ]
  return layout.map((color, index) => ({
    index,
    color,
    multiplier: WHEEL500_COLORS[color].multiplier
  }))
})()

// ============================================================================
// Зашитый цикл из 10 раундов (индексы выигрышных секторов).
// Подобраны разные цвета и редкие хиты (x10, x50), чтобы можно было увидеть всё.
// ============================================================================

const ROUND_CYCLE_WIN_SECTORS = [
  0,   // blue  x2
  5,   // green x3
  3,   // purple x5
  39,  // red   x10
  10,  // blue  x2
  17,  // green x3
  25,  // gold  x50  <- джекпот
  21,  // purple x5
  7,   // red   x10
  46   // green x3
]

// ============================================================================
// Фейковые пользователи для ставок ботов
// ============================================================================

const BOT_NAMES = [
  'Артем', 'Дима', 'Маша', 'Лёша', 'Кирилл', 'Настя', 'Витя', 'Соня',
  'Паша', 'Лена', 'Глеб', 'Юра', 'Рома', 'Олег', 'Стас', 'Игорь',
  'Тёма', 'Ваня', 'Никита', 'Денис', 'Саня', 'Макс', 'Гриша', 'Боря',
  'Зина', 'Карина', 'Аня', 'Лиза', 'Полина', 'Илья'
]

const BOT_AVATARS = [
  '🐺','🦊','🐯','🦁','🐻','🐼','🐸','🐵','🐶','🐱',
  '🦄','🐲','🦅','🦉','🐧','🐙','🦈','🐢','🐍','🦋',
  '🐝','🐞','🦂','🦖','🦘'
]

// Набор мок-скинов (эмодзи вместо реальных картинок): 30 шт.
const SKIN_CATALOG = [
  { id: 'skin-01', emoji: '🔪', name: 'Knife | Night Bite', cost: 2400 },
  { id: 'skin-02', emoji: '🧤', name: 'Gloves | Crimson Grip', cost: 1800 },
  { id: 'skin-03', emoji: '🔫', name: 'AK-47 | Neon Fang', cost: 980 },
  { id: 'skin-04', emoji: '🦅', name: 'AWP | Sky Predator', cost: 1250 },
  { id: 'skin-05', emoji: '🐉', name: 'M4A1-S | Dragon Signal', cost: 890 },
  { id: 'skin-06', emoji: '💀', name: 'USP-S | Bone Script', cost: 510 },
  { id: 'skin-07', emoji: '⚡', name: 'Glock-18 | Volt Cut', cost: 420 },
  { id: 'skin-08', emoji: '🔥', name: 'Desert Eagle | Burn Pulse', cost: 730 },
  { id: 'skin-09', emoji: '🧊', name: 'P250 | Ice Pixel', cost: 310 },
  { id: 'skin-10', emoji: '🌌', name: 'P90 | Deep Space', cost: 650 },
  { id: 'skin-11', emoji: '🌪️', name: 'FAMAS | Storm Arc', cost: 560 },
  { id: 'skin-12', emoji: '🛡️', name: 'MP9 | Steel Guard', cost: 290 },
  { id: 'skin-13', emoji: '🧠', name: 'Five-SeveN | Brainwave', cost: 390 },
  { id: 'skin-14', emoji: '🌋', name: 'Galil AR | Lava Drift', cost: 470 },
  { id: 'skin-15', emoji: '🧬', name: 'MP7 | Bio Core', cost: 530 },
  { id: 'skin-16', emoji: '👾', name: 'MAC-10 | Pixel Invasion', cost: 270 },
  { id: 'skin-17', emoji: '🌙', name: 'SG 553 | Moon Dust', cost: 610 },
  { id: 'skin-18', emoji: '🦂', name: 'UMP-45 | Scorpion Bite', cost: 450 },
  { id: 'skin-19', emoji: '🐍', name: 'Dual Berettas | Viper Pair', cost: 260 },
  { id: 'skin-20', emoji: '🦈', name: 'Nova | Sharkline', cost: 340 },
  { id: 'skin-21', emoji: '☢️', name: 'PP-Bizon | Fallout Tape', cost: 380 },
  { id: 'skin-22', emoji: '🎯', name: 'SSG 08 | Target Grid', cost: 520 },
  { id: 'skin-23', emoji: '💎', name: 'CZ75-Auto | Crystal Hex', cost: 490 },
  { id: 'skin-24', emoji: '🕶️', name: 'R8 Revolver | Dark Agent', cost: 330 },
  { id: 'skin-25', emoji: '🪐', name: 'SCAR-20 | Orbit Dust', cost: 710 },
  { id: 'skin-26', emoji: '🦾', name: 'AUG | Titanium Muscle', cost: 760 },
  { id: 'skin-27', emoji: '🧿', name: 'M249 | Evil Eye', cost: 580 },
  { id: 'skin-28', emoji: '🏁', name: 'XM1014 | Speedline', cost: 350 },
  { id: 'skin-29', emoji: '🧨', name: 'Tec-9 | Blast Script', cost: 410 },
  { id: 'skin-30', emoji: '🪽', name: 'Sawed-Off | Fallen Wing', cost: 300 }
]

const FASES = {
  BETTING:  'betting',   // принимаем ставки
  SPINNING: 'spinning',  // крутим колесо
  RESULT:   'result'     // показываем результат
}

const TIMINGS = {
  BETTING_MS:  15000,
  SPINNING_MS: 6000,
  RESULT_MS:   4000
}

// Веса для распределения ставок ботов (чаще ставят на x2, реже на x50)
const BOT_COLOR_WEIGHTS = {
  blue:   50,
  green:  30,
  purple: 12,
  red:    6,
  gold:   2
}

// Возможные суммы ставок ботов
const BOT_AMOUNTS = [50, 100, 200, 300, 500, 750, 1000, 1500, 2500, 5000]

// Вероятность, что бот поставит со скинами (иначе только кристаллы)
const BOT_SKIN_BET_PROBABILITY = 0.3

// Кол-во ставок ботов в раунд
const BOT_BETS_MIN = 18
const BOT_BETS_MAX = 32

// ============================================================================
// Утилиты
// ============================================================================

const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)]

const pickColorWeighted = () => {
  const totalWeight = Object.values(BOT_COLOR_WEIGHTS).reduce((a, b) => a + b, 0)
  let r = Math.random() * totalWeight
  for (const [color, weight] of Object.entries(BOT_COLOR_WEIGHTS)) {
    r -= weight
    if (r <= 0) return color
  }
  return 'blue'
}

const generateRoundId = () => `mock-${Date.now()}-${Math.floor(Math.random() * 1000)}`

const makeFakeUser = () => ({
  id: `bot-${Math.random().toString(36).slice(2, 9)}`,
  name: pick(BOT_NAMES),
  ava: pick(BOT_AVATARS)
})

const getItemsTotal = (items = []) => {
  return items.reduce((acc, item) => acc + Number(item?.cost || item?.price || 0), 0)
}

const createRandomBetItems = () => {
  if (Math.random() > BOT_SKIN_BET_PROBABILITY) {
    return []
  }

  const count = rand(0, 10)
  if (count <= 0) return []

  const pool = [...SKIN_CATALOG]
  const selected = []

  for (let i = 0; i < count && pool.length > 0; i += 1) {
    const index = rand(0, pool.length - 1)
    const baseItem = pool.splice(index, 1)[0]

    selected.push({
      id: `${baseItem.id}-${Math.random().toString(36).slice(2, 6)}`,
      name: baseItem.name,
      cost: Number(baseItem.cost || 0),
      price: Number(baseItem.cost || 0),
      img: baseItem.emoji,
      emoji: baseItem.emoji
    })
  }

  return selected
}

const createMergedWinSkin = ({ payout, multiplier }) => {
  const baseItem = pick(SKIN_CATALOG)

  return {
    id: `win-${baseItem.id}-${Math.random().toString(36).slice(2, 7)}`,
    name: `${baseItem.name} x${multiplier}`,
    cost: Number(payout || 0),
    price: Number(payout || 0),
    img: baseItem.emoji,
    emoji: baseItem.emoji,
    multiplier
  }
}

// ============================================================================
// Главный движок мока
// ============================================================================

/**
 * Создаёт мок-движок Wheel500.
 * @param {Object} options
 * @param {(state: Object) => void} options.onUpdate - вызывается при любом изменении состояния
 * @returns {{ placeBet: Function, destroy: Function }}
 */
export function createWheel500MockEngine({ onUpdate }) {
  let cycleIndex = 0
  let timers = []
  let botTimers = []
  let isDestroyed = false

  // Текущее состояние раунда (передаётся наружу через onUpdate)
  let state = {
    roundId: null,
    status: FASES.BETTING,
    phaseStartedAt: 0,
    phaseDurationMs: TIMINGS.BETTING_MS,
    winSectorIndex: null,
    winColor: null,
    winMultiplier: null,
    sums: { blue: 0, green: 0, purple: 0, red: 0, gold: 0 },
    bets: [],          // ставки текущего раунда
    recentResults: []  // последние 10 результатов: [{ sectorIndex, color, multiplier }]
  }

  const emit = () => {
    if (isDestroyed) return
    // Эмитим неглубокую копию, чтобы React увидел изменения
    onUpdate({
      ...state,
      sums: { ...state.sums },
      bets: state.bets.slice(),
      recentResults: state.recentResults.slice()
    })
  }

  const clearAllTimers = () => {
    timers.forEach(clearTimeout)
    botTimers.forEach(clearTimeout)
    timers = []
    botTimers = []
  }

  const addBet = ({ user, color, amount, crystal = 0, betItems = [], isMine = false }) => {
    const itemsTotal = getItemsTotal(betItems)
    const safeCrystal = Math.max(0, Number(crystal || 0))
    const safeAmount = Number(amount || 0)
    const sum = Math.max(0, safeAmount || (safeCrystal + itemsTotal))

    const bet = {
      id: `bet-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      user,
      color,
      amount: sum,
      sum,
      crystal: safeCrystal,
      bet_items: Array.isArray(betItems) ? betItems : [],
      chat_id: user?.id || `chat-${Math.random().toString(36).slice(2, 8)}`,
      isMine,
      win: null,
      payout: 0,
      win_skin: null
    }

    state.bets.push(bet)
    state.sums[color] = (state.sums[color] || 0) + sum
    emit()
  }

  const scheduleBotBets = () => {
    const count = rand(BOT_BETS_MIN, BOT_BETS_MAX)
    const window = TIMINGS.BETTING_MS - 800 // оставляем хвост ~0.8с без ставок

    for (let i = 0; i < count; i += 1) {
      const delay = rand(200, window)
      const t = setTimeout(() => {
        if (isDestroyed || state.status !== FASES.BETTING) return

        const betItems = createRandomBetItems()
        const itemsTotal = getItemsTotal(betItems)
        let crystal = pick(BOT_AMOUNTS)

        // Гарантируем ненулевую ставку даже если предметов нет и кристаллы выпали в 0
        if (itemsTotal <= 0 && crystal <= 0) {
          crystal = 100
        }

        addBet({
          user: makeFakeUser(),
          color: pickColorWeighted(),
          crystal,
          betItems,
          amount: crystal + itemsTotal
        })
      }, delay)
      botTimers.push(t)
    }
  }

  // ----- Фазы раунда -----

  const startBettingPhase = () => {
    if (isDestroyed) return

    const winSectorIndex = ROUND_CYCLE_WIN_SECTORS[cycleIndex % ROUND_CYCLE_WIN_SECTORS.length]
    cycleIndex += 1

    state = {
      ...state,
      roundId: generateRoundId(),
      status: FASES.BETTING,
      phaseStartedAt: Date.now(),
      phaseDurationMs: TIMINGS.BETTING_MS,
      winSectorIndex,                              // известен заранее, наружу не показываем
      winColor: WHEEL500_SECTORS[winSectorIndex].color,
      winMultiplier: WHEEL500_SECTORS[winSectorIndex].multiplier,
      sums: { blue: 0, green: 0, purple: 0, red: 0, gold: 0 },
      bets: []
    }
    emit()
    scheduleBotBets()

    timers.push(setTimeout(startSpinningPhase, TIMINGS.BETTING_MS))
  }

  const startSpinningPhase = () => {
    if (isDestroyed) return
    // Очищаем недоехавшие бот-ставки
    botTimers.forEach(clearTimeout)
    botTimers = []

    state = {
      ...state,
      status: FASES.SPINNING,
      phaseStartedAt: Date.now(),
      phaseDurationMs: TIMINGS.SPINNING_MS
    }
    emit()

    timers.push(setTimeout(startResultPhase, TIMINGS.SPINNING_MS))
  }

  const startResultPhase = () => {
    if (isDestroyed) return

    // Помечаем выигравшие ставки
    const winColor = state.winColor
    const winMultiplier = Number(WHEEL500_COLORS[winColor]?.multiplier || 1)
    const bets = state.bets.map((b) => ({
      ...b,
      win: b.color === winColor,
      payout: b.color === winColor ? Math.round(Number(b.sum || b.amount || 0) * winMultiplier) : 0,
      win_skin: b.color === winColor
        ? createMergedWinSkin({
            payout: Math.round(Number(b.sum || b.amount || 0) * winMultiplier),
            multiplier: winMultiplier
          })
        : null
    }))

    const newRecent = [
      {
        sectorIndex: state.winSectorIndex,
        color: state.winColor,
        multiplier: state.winMultiplier
      },
      ...state.recentResults
    ].slice(0, 10)

    state = {
      ...state,
      status: FASES.RESULT,
      phaseStartedAt: Date.now(),
      phaseDurationMs: TIMINGS.RESULT_MS,
      bets,
      recentResults: newRecent
    }
    emit()

    timers.push(setTimeout(startBettingPhase, TIMINGS.RESULT_MS))
  }

  // ----- Публичное API -----

  /**
   * Поставить ставку от текущего пользователя (нашу, "isMine").
   * Разрешено только в фазе betting.
   */
  const placeBet = ({ color, amount, user }) => {
    if (isDestroyed) return { ok: false, error: 'destroyed' }
    if (state.status !== FASES.BETTING) return { ok: false, error: 'locked' }
    if (!WHEEL500_COLORS[color]) return { ok: false, error: 'bad_color' }
    if (!Number.isFinite(amount) || amount <= 0) return { ok: false, error: 'bad_amount' }

    addBet({
      user: user || { id: 'me', name: 'Вы', ava: '🫵' },
      color,
      amount,
      crystal: Number(amount || 0),
      betItems: [],
      isMine: true
    })
    return { ok: true }
  }

  const destroy = () => {
    isDestroyed = true
    clearAllTimers()
  }

  // Стартуем первый раунд
  startBettingPhase()

  return { placeBet, destroy }
}

// ============================================================================
// Константы экспорта для UI (тайминги нужны странице, чтобы синхронить анимацию)
// ============================================================================

export const WHEEL500_TIMINGS = TIMINGS
export const WHEEL500_PHASES = FASES
